import React from "react";
import { AnalyticsPremiumListLoaderTemplate } from "themes/administration/analytics/components";

function AnalyticsPremiumListLoader(props) {
    return <AnalyticsPremiumListLoaderTemplate {...props} />;
}

export default AnalyticsPremiumListLoader;
